import Dashboard from '../components/Dashboard';

export default function InsightsPage({ history }) {
  return <Dashboard reflections={history} />;
}
